const semanticClassNames = {
  root: 'social-player-snapchat',
} as const;

export default semanticClassNames;
